export default __webpack_public_path__ + "static/media/christmas.51d60502.jpg";